import axios from 'axios';
import get from 'lodash/get';

import { PLAN_CATEGORY } from 'config/constants';

import { UPDATE_PROFILE_SUCCESS } from './userActions';

export const CREATE_STRIPE_SUBSCRIPTION_LOADING =
  'CREATE_STRIPE_SUBSCRIPTION_LOADING';
export const CREATE_STRIPE_SUBSCRIPTION_SUCCESS =
  'CREATE_STRIPE_SUBSCRIPTION_SUCCESS';
export const CREATE_STRIPE_SUBSCRIPTION_ERROR =
  'CREATE_STRIPE_SUBSCRIPTION_ERROR';

export const STRIPE_SUBSCRIPTION_LOADING = 'STRIPE_SUBSCRIPTION_LOADING';
export const STRIPE_SUBSCRIPTION_SUCCESS = 'STRIPE_SUBSCRIPTION_SUCCESS';
export const STRIPE_SUBSCRIPTION_SET = 'CUSTOMER_SUBSCIPTION_SET';
export const STRIPE_SUBSCRIPTION_UPDATED = 'CUSTOMER_SUBSCIPTION_UPDATED';
export const STRIPE_SUBSCRIPTION_ERROR = 'STRIPE_SUBSCRIPTION_ERROR';
export const STRIPE_SUBSCRIPTION_NOT_FOUND = 'STRIPE_SUBSCRIPTION_NOT_FOUND';

export function createMembership(data, success, failure) {
  return (dispatch, getState) => {
    const state = getState();

    dispatch({ type: CREATE_STRIPE_SUBSCRIPTION_LOADING });

    axios
      .post(`${process.env.REACT_APP_BACKEND_URL}/stripe/subscriptions`, data, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.user.token}`,
        },
      })
      .then((response) => {
        dispatch({
          type: CREATE_STRIPE_SUBSCRIPTION_SUCCESS,
          payload: response.data.data,
        });

        success && success();
      })
      .catch((error) => {
        if (process.env.NODE_ENV !== 'production') {
          console.log('catch', error);
        }

        let response = get(error, 'response.data');
        if (!response) {
          response = { message: 'Network Error' };
        }

        dispatch({
          type: CREATE_STRIPE_SUBSCRIPTION_ERROR,
          payload: response,
        });
        failure && failure(response);
      });
  };
}

export function upgradeMembership(
  subscriptionId,
  itemId,
  newPlanId,
  trialFromPlan,
  callback,
  failure
) {
  return async (dispatch, getState) => {
    const state = getState();
    dispatch({ type: STRIPE_SUBSCRIPTION_LOADING });

    const headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.user.token}`,
    };

    const body = {
      itemId,
      newPlanId,
    };
    axios
      .post(
        `${process.env.REACT_APP_BACKEND_URL}/stripe/subscriptions/${subscriptionId}/upgrade`,
        body,
        { headers }
      )
      .then((response) => {
        callback && callback();
        dispatch({
          type: STRIPE_SUBSCRIPTION_SUCCESS,
          payload: response.data.data.stripeSubscription,
        });

        dispatch({
          type: UPDATE_PROFILE_SUCCESS,
          payload: response.data.data.account,
        });
      })
      .catch((error) => {
        if (process.env.NODE_ENV !== 'production') {
          console.log('catch', error);
        }

        let response = get(error, 'response.data');
        if (!response) {
          response = { message: 'Network Error' };
        }

        dispatch({
          type: STRIPE_SUBSCRIPTION_ERROR,
          payload: error,
        });
        failure && failure(response);
      });
  };
}

export function resubscribeMembership(
  stripeCustomerId,
  currentSubscriptionId,
  newPlanId,
  refundAmount,
  callback
) {
  return async (dispatch, getState) => {
    const state = getState();
    dispatch({ type: STRIPE_SUBSCRIPTION_LOADING });

    const headers = {
      Authorization: `Bearer ${process.env.REACT_APP_STRIPE_SECRET_KEY}`,
      'Content-Type': 'application/x-www-form-urlencoded',
    };

    // cancel current subscription
    axios
      .delete(
        `${process.env.REACT_APP_STRIPE_HOST_URL}/subscriptions/${currentSubscriptionId}`,
        {
          headers,
        }
      )
      .then(() => {
        // add account balance
        axios
          .post(
            `${process.env.REACT_APP_STRIPE_HOST_URL}/customers/${stripeCustomerId}`,
            `account_balance=-${refundAmount}`,
            { headers }
          )
          .then(() => {
            // create new subscription
            const newSubcriptionData = {
              stripeCustomerId,
              planId: newPlanId,
              category: PLAN_CATEGORY.LANGUAGE,
            };
            axios
              .post(
                `${process.env.REACT_APP_BACKEND_URL}/stripe/subscriptions`,
                newSubcriptionData,
                {
                  headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${state.user.token}`,
                  },
                }
              )
              .then((response) => {
                callback && callback();

                dispatch({
                  type: STRIPE_SUBSCRIPTION_SUCCESS,
                  payload: response.data.data.stripeSubscription,
                });
              })
              .catch((result) => {
                if (process.env.NODE_ENV !== 'production') {
                  console.log('catch', result);
                }

                dispatch({
                  type: STRIPE_SUBSCRIPTION_ERROR,
                  payload: result,
                });
              });
          })
          .catch((result) => {
            dispatch({
              type: STRIPE_SUBSCRIPTION_ERROR,
              payload: result,
            });
          });
      })
      .catch((result) => {
        if (result.response.status === 404) {
          dispatch({
            type: STRIPE_SUBSCRIPTION_NOT_FOUND,
            payload: null,
          });
        } else {
          dispatch({
            type: STRIPE_SUBSCRIPTION_ERROR,
            payload: result,
          });
        }
      });
  };
}



// WEBPACK FOOTER //
// ./src/actions/stripeSubscriptionActions.js